<template>
    <div class="table_data_item">
        <div class="table_data_item_checkbox">
            <checkbox_custom
                :key="'checkbox_custom_head'"
                :checkboxState="isCheck"
                :checkboxBorderPrimaryColor="true"
                @click_checkbox_custom="clickCheckbox"
            />
        </div>
        <div  class="table_data_item_market">
            <div ref="svgContainer" class="table_data_item_market_img">
            </div>
        </div>
        <div class="table_data_item_image">
            <div class="table_data_item_image_img">
                <picture>
                    <source :srcset="imageWebp" type="image/webp">
                    <source :srcset="imagePng" type="image/png">
                    <img :src="imagePng">
                </picture>
            </div>
        </div>
        <div class="table_data_item_product">
            <div class="table_data_item_product_block">
                <div class="table_data_item_product_block_title">
                    {{ productTitle }}
                </div>
                <div class="table_data_item_product_block_aggregator">
                    <div class="table_data_item_product_block_aggregator_name">
                        {{ categoryName }}
                    </div>
                    <div class="table_data_item_product_block_aggregator_id">
                        {{ productUniqId }}
                    </div>
                </div>
            </div>
        </div>
        <div class="table_data_item_restaurant">
            <div class="table_data_item_restaurant_block">
                <div class="table_data_item_restaurant_block_title">
                    {{ restaurantTitle }}
                </div>
                <div class="table_data_item_restaurant_block_id">
                    {{ restaurantId }}
                </div>
            </div>
        </div>
        <div class="table_data_item_location">
            <div class="table_data_item_location_block">
                <div class="table_data_item_location_block_title">
                    {{ locationTitle }}
                </div>
                <div class="table_data_item_location_block_id">
                    {{ locationId }}
                </div>
            </div>
        </div>
        <div class="table_data_item_added">
            <div class="table_data_item_added_block">
                <div class="table_data_item_added_block_date">
                    {{ addedDate }}
                </div>
                <div class="table_data_item_added_block_time">
                    {{ addedTime }}
                </div>
            </div>
        </div>
        <button class="table_data_item_button" @click.prevent="clickButtonStopList">
            <div class="table_data_item_button_row">
                <font-awesome-icon icon="fa-solid fa-xmark" />
            </div>
        </button>
    </div>
</template>

<script>

import checkbox_custom from "../CheckboxCustom.vue";
import insertSvg from "../../mixins/insertSvg";
export default {
    name: "table_data_item",
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
    components: {
        checkbox_custom
    },
    emits: ['click_button_stop_list'],
    mixins:[insertSvg],
    data() {
        return {
        }
    },
    mounted() {
        if (this.item.aggregator && this.item.aggregator.icon && this.item.aggregator.icon !== '') {
            this.insertSvg(this.item.aggregator.icon);
        }
    },
    methods: {
        clickCheckbox(){
            this.item.isCheck = !this.item.isCheck;
        },
        clickButtonStopList() {
            this.$emit('click_button_stop_list', this.item);
        },
    },
    computed: {
        isCheck() {
            if(this.item && this.item.isCheck) {
                return true;
            }
            return false;
        },
        imageWebp() {
            if (this.item.image && this.item.image.webp) {
                return this.item.image.webp;
            }
            return '';
        },
        imagePng() {
            if (this.item.image && this.item.image.png) {
                return this.item.image.png;
            }
            return '';
        },
        productTitle() {
            if(this.item.product && this.item.product.title){
                return this.item.product.title;
            }
            return 'No title product';
        },
        categoryName() {
            if(this.item.main_category && this.item.main_category.title){
                return this.item.main_category.title;
            }
            return 'No category title';
        },
        productUniqId() {
            if(this.item.product_uniq){
                return this.item.product_uniq;
            }
            return 'No title product';
        },
        restaurantTitle(){
            if(this.item.restaurant && this.item.restaurant.title){
                return this.item.restaurant.title;
            }
            return 'No title restaurant';
        },
        restaurantId(){
            if(this.item.restaurant && this.item.restaurant.uniq_id){
                return this.item.restaurant.uniq_id;
            }
            return 'No uniq_id restaurant';
        },
        locationTitle() {
            if(this.item.location && this.item.location.title){
                return this.item.location.title;
            }
            return 'No title location';
        },
        locationId() {
            if(this.item.location && this.item.location.uniq_id){
                return this.item.location.uniq_id;
            }
            return 'No location uniq_id';
        },
        addedArray(){
            if(this.item.added) {
                return this.item.added.split(' ');
            }
            return [];
        },
        addedDate() {
            if(this.addedArray.length === 2) {
                return this.addedArray[0];
            }
            return 'No added date';
        },
        addedTime() {
            if(this.addedArray.length === 2) {
                return this.addedArray[1];
            }
            return 'No added time';
        },
    },
}
</script>
